import type { $Fetch } from 'nitropack';

import type { DiscountVoucher } from '~/models';

interface Filter {
  startDate?: string;
  endDate?: string;
  productUuid?: string;
  voucherCode?: string;
  onlyActive?: boolean;
  takeawayOption?: string;
  totalItem?: number;
  totalOrder?: number;
  deliveryFee?: number;
  cartUuid?: string;
}

export default class DiscountService {
  constructor(private fetch: $Fetch) { }

  async fixed(filter?: Filter): Promise<number> {
    return await this.fetch<number>('/discounts/fixed', {
      query: filter
    });
  }

  async voucher(filter?: Filter): Promise<DiscountVoucher> {
    return await this.fetch<DiscountVoucher>('/discounts/voucher', {
      query: filter
    });
  }

  async order(filter?: Filter): Promise<number> {
    return await this.fetch<number>('/discounts/order', {
      query: filter
    });
  }

  async deliveryFee(filter?: Filter): Promise<number> {
    return await this.fetch<number>('/discounts/delivery-fee', {
      query: filter
    });
  }
}

export type { Filter };
